module.exports = __webpack_public_path__ + "img/imageKey2.75db6f1.jpg";